import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type LoadingKind = 'save' | 'load';

export interface LoadingState {
    visible: boolean;
    message: string;
}

const SHOW_DELAY_MS = 300;
const MIN_VISIBLE_MS = 400;

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private pending = 0;
    private saves = 0;
    private visible = false;
    private shownAt = 0;
    private showTimer: ReturnType<typeof setTimeout> | null = null;
    private hideTimer: ReturnType<typeof setTimeout> | null = null;

    private readonly stateSubject = new BehaviorSubject<LoadingState>({
        visible: false,
        message: 'Caricamento'
    });

    readonly state$ = this.stateSubject.asObservable();

    begin(kind: LoadingKind): void {
        this.pending++;
        if (kind === 'save') {
            this.saves++;
        }
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }
        if (!this.visible && !this.showTimer) {
            this.showTimer = setTimeout(() => {
                this.showTimer = null;
                this.visible = true;
                this.shownAt = Date.now();
                this.publish();
            }, SHOW_DELAY_MS);
        } else if (this.visible) {
            this.publish();
        }
    }

    end(kind: LoadingKind): void {
        this.pending = Math.max(0, this.pending - 1);
        if (kind === 'save') {
            this.saves = Math.max(0, this.saves - 1);
        }
        if (this.pending > 0) {
            if (this.visible) {
                this.publish();
            }
            return;
        }
        if (this.showTimer) {
            clearTimeout(this.showTimer);
            this.showTimer = null;
            return;
        }
        if (!this.visible) {
            return;
        }
        const elapsed = Date.now() - this.shownAt;
        const wait = Math.max(0, MIN_VISIBLE_MS - elapsed);
        this.hideTimer = setTimeout(() => {
            this.hideTimer = null;
            this.visible = false;
            this.publish();
        }, wait);
    }

    private publish(): void {
        this.stateSubject.next({
            visible: this.visible,
            message: this.saves > 0 ? 'Salvataggio' : 'Caricamento'
        });
    }
}
